import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { ErrorType } from '../models/commonTypeScript';
import { toErrorType } from '../sagas/isErrorType';
import { fetchFromDashboardApi } from './fetch';
import getFetchHeaders from './getFetchHeaders';

export const baseQuery: BaseQueryFn<
    {
        url: string;
        method: string;
        data?: unknown;
        params?: Record<string, string>;
    },
    unknown,
    ErrorType
> = async ({ url, method, data }) => {
    try {
        const headers = await getFetchHeaders();
        const result = await fetchFromDashboardApi(url, {
            method,
            headers,
            body: data ? JSON.stringify(data) : undefined,
        });
        return { data: result };
    } catch (error) {
        const asErrorType = toErrorType(error);
        return { error: asErrorType };
    }
};

export default baseQuery;
